import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, effect, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SelectComponent } from 'src/app/shared/select/select.component';
import { campusServices } from 'src/app/services/campus.service';
import { userServices } from 'src/app/services/users.service';
import { programService } from 'src/app/services/program.service';
import { stepService } from 'src/app/services/step.service';
import { leadServices } from 'src/app/services/leads.service';
import { cohortsService } from 'src/app/services/cohorts.service';
import { combineLatest, firstValueFrom } from 'rxjs';
import { MatAccordion } from '@angular/material/expansion';


import {
  prefixes,
  degreeOptions,
  ethnicities,
  bestTimeToCallOptions,
  maritalStatuses,
  contactMethods,
  genders,
} from '../../interface-data/data';
import { phoneValidator } from 'src/app/shared/helper/password.validator';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/dialog/confirm.dialog';
import { CustomDatePipe } from 'src/app/pipe/date-format.pipe';
import { ItemComponent } from 'src/app/shared/item/item.component';
import { noteService } from 'src/app/services/note-service';
import { CardItemComponent } from '../tabs/activity/card-item/card-item.component';
import { CommunicationService } from '../signal-lead.serice';
import { tasksServices } from 'src/app/services/tasks.service';
import { isThisSecond } from 'date-fns';
import { tagsService } from 'src/app/services/tags.service';
import { ChatItemComponent } from '../tabs/email-sms/chat-item/chat-item.component';
import { Router } from '@angular/router';
import { CampusCacheService } from 'src/app/services/cache/campus-cache';
import { TagsCacheService } from 'src/app/services/cache/tags-cache';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { ActivityCompletionService } from 'src/app/services/activity-completion.service';
import { AutoCompleteComponent } from 'src/app/shared/auto-complete/auto-complete.component';
import { HtmlEditorComponent } from 'src/app/shared/html-editor/html-editor.component';
import { CompactCallButtonComponent } from 'src/app/shared/compact-call-button/compact-call-button.component';
import { UsersCacheService } from 'src/app/services/cache/users-cache';
import { ActivityLeadService } from 'src/app/services/lead-activity.servise';
import { userDataService } from 'src/app/services/userDataService';
import { CallFeatureService } from 'src/app/services/call-feature.service';
import { SocketService } from 'src/app/services/socket.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-lead-info',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SelectComponent,
    CustomDatePipe,
    ItemComponent,
    CardItemComponent,
    ChatItemComponent,
    AutoCompleteComponent,
    HtmlEditorComponent,
    CompactCallButtonComponent
  ],
  templateUrl: './lead-info.component.html',
  styleUrl: './lead-info.component.scss',
})
export class LeadInfoComponent implements OnInit, OnDestroy {
  lead = input<any>();
  currentLead: any;
  updateLead = output<any>();
  fullNameCurrentUser: string;
  callsEnabled: boolean = false;

  // Flag to track if programs and cohorts have been loaded
  private academicDataLoaded = false;
  
  private destroy$ = new Subject<void>();

  // Current user ID for filtering socket events
  private currentUserId: number | null = null;

  // Existing option arrays
  genders = genders;
  contactMethods = contactMethods;
  prefixes = prefixes;
  degreeOptions = degreeOptions;
  ethnicities = ethnicities;
  bestTimeToCallOptions = bestTimeToCallOptions;
  maritalStatuses = maritalStatuses;

  today = new Date();

  // Referral types and options
  referralTypes = [
    { id: 'user', name: 'Staff Member' },
    { id: 'lead', name: 'Another Lead' }
  ];
  
  // Options for referrals
  referralOptions: {id: string, name: string}[] = [];
  referrals: any[] = [];

  // Quill editor configuration
  quillModule = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'], // Basic formatting
        [{ list: 'ordered' }, { list: 'bullet' }], // Lists
        ['clean'], // Clear formatting
        ['speechToText'], // Add speech-to-text button
      ],
      handlers: {
        speechToText: () => {}, // Placeholder for now
      },
    },
  };

  // Form groups
  personalInfoForm: FormGroup;
  contactInfoForm: FormGroup;
  academicInfoForm: FormGroup;
  leadInfoForm: FormGroup;
  citizenshipInfoForm: FormGroup;
  referralInfoForm: FormGroup; // New form for referrals
  paymentPlanForm: FormGroup;

  // Existing properties
  users: any;
  campuses: any;
  programs: any;
  cohorts: any = [];
  availableTags: any;
  steps: any;
  showChat: boolean = false;

  editMode = {
    personalInfoForm: false,
    contactInfoForm: false,
    academicInfoForm: false,
    leadInfoForm: false,
    citizenshipInfoForm: false,
    referralInfoForm: false, // Added for referrals
    paymentPlanForm: false,
    studentInfo: false,
    financialAidForm: false,
  };

  expansionStatus = {
    personalInfoForm: false,
    contactInfoForm: false,
    academicInfoForm: false,
    leadInfo: false,
    citizenshipInfoForm: false,
    referralInfoForm: false, // Added for referrals
    paymentPlanForm: false,
    studentInfo: false,
    financialAidForm: false,
  };
  chat: any;

    // Financial Aid
    financialAidForm: FormGroup;
    faStatuses: any[] = [];
    faOverallStatuses: any[] = [];
    faDependencyTypes: any[] = [];
    faVerificationStatuses: any[] = [];
    private faOptionsLoaded = false;

    private previousLeadId: number | null = null;
    @ViewChild(MatAccordion) accordion: MatAccordion;

    fafsaPendingFile: File | null = null;


  constructor(
    private fb: FormBuilder,
    private programSrvice: programService,
    private leadService: leadServices,
    private cohortService: cohortsService,
    private noteService: noteService,
    private dialog: MatDialog,
    private CommunicationService: CommunicationService,
    private taskService: tasksServices,
    private router: Router,
    private campusCacheService: CampusCacheService,
    private tagsCacheService: TagsCacheService,
    private userCacheService: UsersCacheService,
    private notificationService: NotificationsService,
    private userService: userServices,
    private activityCompletionService: ActivityCompletionService,
    private activityLeadService: ActivityLeadService,
    private userDataService: userDataService,
    private callFeatureService: CallFeatureService,
    private socketService: SocketService,
    private cdr: ChangeDetectorRef
  ) {
    // Single effect for lead changes
effect(() => {
  this.currentLead = this.lead();

  if (this.currentLead) {
    // Detect lead change and reset component state
    if (this.previousLeadId !== null && this.previousLeadId !== this.currentLead.id) {
      this.resetComponentState();
    }
    this.previousLeadId = this.currentLead.id;

    this.showChat = this.currentLead?.is_last_message_from_lead;
    this.chat = this.currentLead?.messages?.[0] ? {...this.currentLead.messages[0]} : null;

    this.fullNameCurrentUser =
      this.currentLead.user?.name + ' ' + this.currentLead.user?.lastName;
    this.loadData();
    this.loadAccademic(false);
    this.cdr.detectChanges();
  }
}, { allowSignalWrites: true });
    
    this.initializeForms();
  }
  
  async ngOnInit() {
    this.loadOptions();

    // Get current user ID for socket event filtering
    try {
      const userData = await this.userDataService.getUserData();
      this.currentUserId = userData?.id || null;
    } catch (error) {
      console.error('Failed to get user data:', error);
    }

    // Subscribe to call feature status
    this.callFeatureService.callsEnabled$.subscribe(enabled => {
      this.callsEnabled = enabled;
    });

    this.setupFocusSocketListener();
  }

  // Method to be called when Lead Info tab is selected
  async onLeadInfoTabSelected() {
    // Load academic data if not already loaded
    if (!this.academicDataLoaded) {
      await this.loadAcademicDataForEdit();
    }
  }

  onTabChange(event: any) {
    if (event.index === 1) {
      this.onLeadInfoTabSelected();
    }
  }

  openChat() {
    this.router.navigate([], {
      queryParams: { section: 0 },
      queryParamsHandling: 'merge', // Preserve existing query parameters
      skipLocationChange: false // Keep the browser URL updated
    });
  }
  
  onEmployeeSelected(e) {
  }

  initializeForms() {
    // Personal Info Form
    this.personalInfoForm = this.fb.group({
      name: [''],
      lastName: [''],
      birth_date: [''],
      gender: [''],
      marital_status: [''],
      race_ethnicity: [''],
      highestDegreeEarned: [''],
      highSchoolYearGraduation: [''],  // Changed
      studentUserId: [''],
    });

    // Contact Info Form
    this.contactInfoForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      prefix: ['+1', Validators.required], // Add prefix field
      phoneNumber: [
        '',
        {
          validators: [Validators.required, phoneValidator()],
          updateOn: 'blur',
        },
      ],
      mobilePhone: [''],
      homePhone: [''],
      address: [''],
      city: [''],
      state: [''],
      zip_code: [''],
      preferred_contact_method: [''],
      best_time_to_call: [''],
      studentUserId: [''],
    });

    // Academic Info Form
    this.academicInfoForm = this.fb.group({
      program: ['', Validators.required],
      cohort_start: [''],
      campus: ['', Validators.required],
    });

    // Lead Info Form
    this.leadInfoForm = this.fb.group({
      user: [''],
      secondaryUser: [''],
      lead_in_date: [''],
      source: [''],
      vendorSource: [''],
    });

    // Payment Plan Form
    this.paymentPlanForm = this.fb.group({
      payment_plan_start_date: [''],
      payment_plan_end_date: [''],
    }, { validators: this.paymentPlanDateValidator });

    // Citizenship Info Form
    this.citizenshipInfoForm = this.fb.group({
      usCitizen: [],
      vaMilitary: [],
    });
    
    // Referral Info Form
    this.referralInfoForm = this.fb.group({
      referralType: [''],
      referredById: [''],
      referralCode: [''],
      referralNote: ['']
    });

    this.financialAidForm = this.fb.group({
      fa_status_id: [null],
      fa_overall_status_id: [null],
      fa_dependency_type_id: [null],
      fa_verification_status_id: [null],
      fafsa_filed: [false],
      fafsa_submitted_at: [null],
      fa_appointment_at: [null],
      fa_completed_at: [null],
      sar_received: [false],
      sai_amount: [null],
      award_letter_sent: [false],
      award_letter_sent_at: [null],
      aid_accepted: [null],
      aid_amount: [null],
      fa_advisor_id: [null],
      expected_start_date: [null],
      fa_notes: [''],
    }, { validators: this.faDateValidator });
  }

  async loadOptions() {
    this.campusCacheService.fetchData();
    this.tagsCacheService.fetchData();
    this.userCacheService.fetchData();
  
    combineLatest([
      this.campusCacheService.data$,
      this.tagsCacheService.data$,
      this.userCacheService.data$,
    ]).subscribe(([campuses, tags, users]) => {
      this.campuses = campuses;
      this.availableTags = tags;
      this.users = users.map(row => ({
        id: row.id,
        name: `${row.name} ${row.lastName}`,
        firstName: row.name,
        lastName: row.lastName,
      }));
    });
  
    // Load all FA config options in one shot (cached on backend)
    try {
      const faConfig: any = await firstValueFrom(this.leadService.getFaConfig());
      this.faStatuses = faConfig.faStatuses;
      this.faOverallStatuses = faConfig.faOverallStatuses;
      this.faDependencyTypes = faConfig.faDependencyTypes;
      this.faVerificationStatuses = faConfig.faVerificationStatuses;
    } catch (error) {
      console.error('Error loading FA config:', error);
    }
  }

  async getCohorts(programId?: number | null, campusId?: number | null, isInit?: boolean) {
    const params: any = {};
    
    // Always include both campus_id and program_id in the request
    if (campusId) {
      params.campus_id = campusId;
    }
    if (programId) {
      params.program_id = programId;
    }
    
    // If neither is provided, fetch all cohorts
    const response = await firstValueFrom(
      this.cohortService.get(Object.keys(params).length > 0 ? params : {}),
    );
    this.cohorts = response.data || [];
    
    // When initializing, check if current cohort is in the list
    if (isInit && this.currentLead?.cohort?.id) {
      const currentCohortInList = this.cohorts.find(c => c.id === this.currentLead.cohort.id);
      
      // If the current cohort is not in the list, add it with unavailable flag
      if (!currentCohortInList && this.currentLead.cohort) {
        const unavailableCohort = {
          ...this.currentLead.cohort,
          title: `${this.currentLead.cohort.title} (No longer available)`,
          isUnavailable: true
        };
        this.cohorts = [...this.cohorts, unavailableCohort];
      }
    }
  }

  async getProgram(id: number | null, isInit: boolean) {
    // When initializing, we need to check if the current program is still related to the campus
    if (isInit && this.currentLead?.program?.id) {
      // First, get programs for the campus
      const response = await firstValueFrom(
        this.programSrvice.get(id != null ? { id } : {}),
      );
      this.programs = response.data || [];
      
      // Check if the current program is in the list
      const currentProgramInList = this.programs.find(p => p.id === this.currentLead.program.id);
      
      // If the current program is not in the campus programs list, add it manually with a flag
      if (!currentProgramInList && this.currentLead.program) {
        const unavailableProgram = {
          ...this.currentLead.program,
          name: `${this.currentLead.program.name} (No longer available)`,
          isUnavailable: true
        };
        this.programs = [...this.programs, unavailableProgram];
      }
    } else {
      // Normal case - just get programs for the campus
      const response = await firstValueFrom(
        this.programSrvice.get(id != null ? { id } : {}),
      );
      this.programs = response.data || [];
    }
    
    // If not initializing, also load cohorts for this campus
    if (!isInit && id) {
      await this.getCohorts(null, id);
    }
  }
  
  // Update onCampusChange method
  onCampusChange(selectedCampusId: number | null) {
    // Reset downstream fields
    this.programs = [];
    this.cohorts = [];
    this.academicInfoForm.get('program')!.reset();
    this.academicInfoForm.get('cohort_start')!.reset();

    // Load programs and cohorts for the new campus
    if (selectedCampusId != null) {
      this.getProgram(selectedCampusId, false);
    }
  }

  // Update onProgramChange method
  onProgramChange(selectedProgramId: number | null) {
    // Reset cohort dropdown
    this.academicInfoForm.get('cohort_start')!.reset();
    this.cohorts = [];

    // Get the current campus ID
    const campusId = this.academicInfoForm.get('campus')?.value;

    // Load cohorts with both program and campus filters
    if (selectedProgramId != null || campusId != null) {
      this.getCohorts(selectedProgramId, campusId);
    }
  }

  // New method to load programs and cohorts when editing academic info
  async loadAcademicDataForEdit() {
    if (!this.academicDataLoaded) {
      try {
        // Load both programs and cohorts in parallel
        await Promise.all([
          this.getProgram(this.currentLead?.campus?.id ?? null, true),
          this.getCohorts(
            this.currentLead?.program?.id ?? null, 
            this.currentLead?.campus?.id ?? null,
            true
          )
        ]);
        
        this.academicDataLoaded = true;
      } catch (error) {
        console.error('Error loading programs and cohorts:', error);
      }
    }
  }

  onReferralTypeChange(event: any) {
    // Reset the referredById when changing referral type
    this.referralInfoForm.get('referredById').reset();
    
    // If switching to lead type, load lead options
    if (event.value === 'lead') {
      this.getReferrals();
    }
  }
  
  async handleReferralValueChanged(search: string) {
    if (this.referralInfoForm.get('referralType').value === 'lead') {
      // Only search for leads when in lead referral mode
      this.getReferrals(search);
    }
  }
  
  async getReferrals(search?: string) {
    const response = await firstValueFrom(
      this.leadService.get(
        {
          pageIndex: 1,
          pageSize: 5,
          searchValue: search ? search : '',
          preselectedId: this.referralInfoForm.get('referredById').value
        },
        'leadSearch',
      ),
    );
    
    this.referralOptions = response.data.map((item: any) => ({
      name: item.fullName || 'No name',
      id: item.id
    }));
    this.referrals = response.data;
  }
  
  referralChange(event: any) {
  }

  getTimeTypeControl(index: number) {}

  onSelectionChange(e) {
  }
  
  onDateChange(event: any): void {
    const selectedDate: Date = event.value;
    if (selectedDate) {
      // Get the date components from the local date
      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      
      // Create a date string in YYYY-MM-DD format
      const dateString = `${year}-${month}-${day}`;
      
      // Update the form control with the date string
      this.personalInfoForm.get('birth_date').setValue(dateString);
    }
  }

  loadData() {
    if (this.currentLead) {
      this.personalInfoForm.patchValue({
        name: this.currentLead?.name || '',
        lastName: this.currentLead?.lastName || '',
        birth_date: this.currentLead.birth_date || null,
        gender: this.currentLead?.gender || '',
        marital_status: this.currentLead?.marital_status || '',
        race_ethnicity: this.currentLead?.race_ethnicity || '',
        highestDegreeEarned: this.currentLead?.highestDegreeEarned || '',
        highSchoolYearGraduation: this.currentLead?.highSchoolYearGraduation || '',  // Changed
        studentUserId: this.currentLead.studentUser?.id || null,
      });

      this.contactInfoForm.patchValue({
        email: this.currentLead?.email || '',
        prefix: this.currentLead?.prefix || '',
        phoneNumber: this.currentLead?.phoneNumber || '',
        mobilePhone: this.currentLead?.mobilePhone || '',
        homePhone: this.currentLead?.homePhone || '',
        address: this.currentLead?.address || '',
        city: this.currentLead?.city || '',
        state: this.currentLead?.state || '',
        zip_code: this.currentLead?.zip_code || '',
        preferred_contact_method:
          this.currentLead?.preferred_contact_method || '',
        best_time_to_call: this.currentLead?.best_time_to_call || '',
        studentUserId: this.currentLead.studentUser?.id || null,
      });

      this.leadInfoForm.patchValue({
        lead_in_date: this.currentLead?.lead_in_date || null,
        source: this.currentLead?.leadSource?.name || '',
        vendorSource: this.currentLead?.vendorSource?.name || '',
      });

      this.paymentPlanForm.patchValue({
        payment_plan_start_date: this.currentLead?.payment_plan_start_date || null,
        payment_plan_end_date: this.currentLead?.payment_plan_end_date || null,
      });

      this.citizenshipInfoForm.patchValue({
        usCitizen: this.currentLead?.usCitizen,
        vaMilitary: this.currentLead?.vaMilitary,
      });

      this.loadFinancialAidData();

      // Load display info for academic section
      this.loadInfo(false);
      this.loadReferralData();
    }
  }

  // Load referral data
  loadReferralData() {
    if (this.currentLead && this.currentLead.referral) {
      const referral = this.currentLead.referral;
      let referralType = '';
      let referredById = '';
      
      if (referral.referredByUser) {
        referralType = 'user';
        referredById = referral.referredByUser.id?.toString() || '';
      } else if (referral.referredByLead) {
        referralType = 'lead';
        referredById = referral.referredByLead.id?.toString() || '';
      }
      
      this.referralInfoForm.patchValue({
        referralType: referralType,
        referredById: referredById,
        referralCode: referral.referralCode || '',
        referralNote: referral.note || ''
      });
    } else {
      // Reset the form if no referral data
      this.referralInfoForm.patchValue({
        referralType: '',
        referredById: '',
        referralCode: '',
        referralNote: ''
      });
    }
  }

  // Add this method to prepare referral data for submission
  prepareReferralDataForSubmission() {
    const formValue = this.referralInfoForm.value;
    const referralData = {};
    
    if (formValue.referralType) {
      referralData['referral'] = {
        referralCode: formValue.referralCode || null,
        note: formValue.referralNote || null
      };
      
      if (formValue.referralType === 'user') {
        referralData['referral']['referredByUserId'] = +formValue.referredById;
        referralData['referral']['referredByLeadId'] = null;
      } else if (formValue.referralType === 'lead') {
        referralData['referral']['referredByUserId'] = null;
        referralData['referral']['referredByLeadId'] = +formValue?.referredById?.id;
      }
    } else if (this.currentLead?.referral) {
      // If referral type is empty/none, set to null to remove referral
      referralData['referral'] = { removeReferral: true };
    } else {
      referralData['referral'] = null;
    }
    
    return referralData;
  }

  async toggleEdit(section: string, event?: any) {
    if (this.editMode[section] && (this[section].dirty || (section === 'financialAidForm' && this.fafsaPendingFile))) {
      // Check if the form values actually changed by comparing with original values
      const formChanged = this.hasFormChanged(section);
      
      if (formChanged) {
        if (!this[section].valid) return;
        this.editMode[section] = false;
        
        if (this.currentLead.isDuplicated && (section == 'personalInfoForm' || section == 'contactInfoForm')) {
          this.notificationService.showNonErrorSnackBar(`You cannot update ${section === 'personalInfoForm' ? 'Personal info' : 'Contact info'} without merging this duplicated lead`, 2000);
          this.resetForm(section);
          return;
        }

        // Handle referral data specifically
        if (section === 'referralInfoForm') {
          const referralData = this.prepareReferralDataForSubmission();
          const responsee = await firstValueFrom(
            this.leadService.put(referralData, this.currentLead.id),
          );
          
          if (responsee) {
            this.updateLead.emit(responsee);
            return;
          }
          // in toggleEdit(), academicInfoForm branch — after updateLead.emit(responsee)
} else if (section === 'academicInfoForm') {
  let academicInfo: any = JSON.parse(JSON.stringify(this.academicInfoForm.value));
  const programChanged = academicInfo?.program !== this.currentLead?.program?.id?.toString();

  if (programChanged) {
    academicInfo.programChanged = true;

    const response = await this.callDialog(
      'Program Has Changed',
      'Are you sure you want to change the program? This will reset all document procedures.'
    );
    if (!response) return;
  }

  const responsee = await firstValueFrom(
    this.leadService.put(academicInfo, this.currentLead.id),
  );

  if (responsee) {
    this.updateLead.emit(responsee);

    // ✅ NEW: tell the tabs to drop the Documents cache
    if (programChanged) {
      this.CommunicationService.updateData({
        type: 'reset-documents-tab',
      });
    }
    return;
  }
} else if (section === 'financialAidForm') {
          await this.saveFinancialAid();
          this.editMode[section] = false;
          return;
        } else {
          // Handle other forms as before
          const responsee = await firstValueFrom(
            this.leadService.put(this[section].value, this.currentLead.id),
          );
          
          if (responsee) {
            this.updateLead.emit(responsee);
            return;
          }
        }
      } else {
        // No actual changes made, so just toggle edit mode without saving
        this.editMode[section] = false;
        return;
      }
    }
    
    if (section == 'academicInfoForm' && !this.editMode[section]) {
      this.loadAccademic(true);
    }
    
    if (!this.editMode[section] && this.expansionStatus[section]) {
      event.stopPropagation();
    }
    
    this.editMode[section] = !this.editMode[section];
  }

  onPanelOpened(section) {
    this.expansionStatus[section] = true;
  }

  hasFormChanged(section: string): boolean {
    // Compare current form values with original values from the lead
    switch (section) {
      case 'personalInfoForm':
        return (
          this.personalInfoForm.get('name').value !== (this.currentLead?.name || '') ||
          this.personalInfoForm.get('lastName').value !== (this.currentLead?.lastName || '') ||
          this.personalInfoForm.get('birth_date').value !== (this.currentLead.birth_date || null) ||
          this.personalInfoForm.get('gender').value !== (this.currentLead?.gender || '') ||
          this.personalInfoForm.get('marital_status').value !== (this.currentLead?.marital_status || '') ||
          this.personalInfoForm.get('race_ethnicity').value !== (this.currentLead?.race_ethnicity || '') ||
          this.personalInfoForm.get('highestDegreeEarned').value !== (this.currentLead?.highestDegreeEarned || '') ||
          this.personalInfoForm.get('highSchoolYearGraduation').value !== (this.currentLead?.highSchoolYearGraduation || '') ||
          this.personalInfoForm.get('studentUserId').value !== (this.currentLead.studentUser?.id || null)
        );
        
      case 'contactInfoForm':
        return (
          this.contactInfoForm.get('email').value !== (this.currentLead?.email || '') ||
          this.contactInfoForm.get('prefix').value !== (this.currentLead?.prefix || '') ||
          this.contactInfoForm.get('phoneNumber').value !== (this.currentLead?.phoneNumber || '') ||
          this.contactInfoForm.get('mobilePhone').value !== (this.currentLead?.mobilePhone || '') ||
          this.contactInfoForm.get('homePhone').value !== (this.currentLead?.homePhone || '') ||
          this.contactInfoForm.get('address').value !== (this.currentLead?.address || '') ||
          this.contactInfoForm.get('city').value !== (this.currentLead?.city || '') ||
          this.contactInfoForm.get('state').value !== (this.currentLead?.state || '') ||
          this.contactInfoForm.get('zip_code').value !== (this.currentLead?.zip_code || '') ||
          this.contactInfoForm.get('preferred_contact_method').value !== (this.currentLead?.preferred_contact_method || '') ||
          this.contactInfoForm.get('best_time_to_call').value !== (this.currentLead?.best_time_to_call || '') ||
          this.contactInfoForm.get('studentUserId').value !== (this.currentLead.studentUser?.id || null)
        );
        
        case 'financialAidForm':
          if (this.fafsaPendingFile) return true; // ADD THIS LINE at the top of the case
          const faFields = [
            'fa_status_id', 'fa_overall_status_id', 'fa_dependency_type_id',
            'fa_verification_status_id', 'fafsa_filed', 'fafsa_submitted_at',
            'fa_appointment_at', 'fa_completed_at', 'sar_received', 'sai_amount',
            'award_letter_sent', 'award_letter_sent_at', 'aid_accepted',
            'aid_amount', 'fa_advisor_id', 'expected_start_date', 'fa_notes',
          ];
          return faFields.some((field) => {
            const formVal = this.financialAidForm.get(field)?.value;
            const origVal = this.currentLead?.[field];
            const normalize = (v: any) => (v === '' || v === undefined || v === 'pending' ? null : v);
            return normalize(formVal) !== normalize(origVal);
          });

          
      case 'academicInfoForm':
        if (this.editMode[section]) {
          return (
            this.academicInfoForm.get('program').value !== (this.currentLead?.program?.id?.toString() || '') ||
            this.academicInfoForm.get('cohort_start').value !== (this.currentLead?.cohort?.id?.toString() || '') ||
            this.academicInfoForm.get('campus').value !== (this.currentLead?.campus?.id?.toString() || '')
          );
        } else {
          return false;
        }
        
      case 'citizenshipInfoForm':
        return (
          this.citizenshipInfoForm.get('usCitizen').value !== this.currentLead?.usCitizen ||
          this.citizenshipInfoForm.get('vaMilitary').value !== this.currentLead?.vaMilitary
        );
        
      case 'paymentPlanForm':
        return (
          this.paymentPlanForm.get('payment_plan_start_date').value !== (this.currentLead?.payment_plan_start_date || null) ||
          this.paymentPlanForm.get('payment_plan_end_date').value !== (this.currentLead?.payment_plan_end_date || null)
        );

      case 'referralInfoForm':
        const referral = this.currentLead?.referral;
        const formValue = this.referralInfoForm.value;
        
        // If there's no referral in the current lead
        if (!referral) {
          // If any field in the form has a value, then there's a change
          return !!(formValue.referralType || formValue.referredById || formValue.referralCode || formValue.referralNote);
        }
        
        // Check referral type
        let originalReferralType = '';
        let originalReferredById = '';
        
        if (referral.referredByUser) {
          originalReferralType = 'user';
          originalReferredById = referral.referredByUser.id?.toString() || '';
        } else if (referral.referredByLead) {
          originalReferralType = 'lead';
          originalReferredById = referral.referredByLead.id?.toString() || '';
        }
        
        return (
          formValue.referralType !== originalReferralType ||
          formValue.referredById !== originalReferredById ||
          formValue.referralCode !== (referral.referralCode || '') ||
          formValue.referralNote !== (referral.note || '')
        );
        
      default:
        return this[section].dirty; // Fall back to dirty check for unknown forms
    }
  }

  async onPanelClosed(section) {
    if (this.editMode[section] && (this[section].dirty || (section === 'financialAidForm' && this.fafsaPendingFile))) {
  
      if (!this[section].valid) {
        this.resetForm(section);
        this.notificationService.showNonErrorSnackBar('Changes were not saved — form contains invalid values', 3000);
      } else if (section === 'paymentPlanForm' && this.paymentPlanForm.hasError('startAfterEnd')) {
        this.resetForm(section);
        this.notificationService.showNonErrorSnackBar('Changes were not saved — start date cannot be after end date', 3000);
      } else {
        const formChanged = this.hasFormChanged(section);
  
        if (formChanged) {
          const confirmed = await this.callDialog('Unsaved Changes', 'You have unsaved changes. Do you want to save previous changes?');
  
          if (confirmed) {
            if (this.currentLead.isDuplicated && (section == 'personalInfoForm' || section == 'contactInfoForm')) {
              this.notificationService.showNonErrorSnackBar(`You cannot update ${section === 'personalInfoForm' ? 'Personal info' : 'Contact info'} without merging this duplicated lead`, 2000);
              this.resetForm(section);
            } else if (section === 'referralInfoForm') {
              const referralData = this.prepareReferralDataForSubmission();
              const responsee = await firstValueFrom(this.leadService.put(referralData, this.currentLead.id));
              if (responsee) { this.updateLead.emit(responsee); }
            } else if (section === 'academicInfoForm') {
              const responsee = await firstValueFrom(this.leadService.put(this.academicInfoForm.value, this.currentLead.id));
              if (responsee) { this.updateLead.emit(responsee); }
            } else if (section === 'financialAidForm') {
              await this.saveFinancialAid();
            } else {
              const responsee = await firstValueFrom(this.leadService.put(this[section].value, this.currentLead.id));
              if (responsee) { this.updateLead.emit(responsee); }
            }
          } else {
            this.resetForm(section);
          }
        }
      }
    }
  
    if (section == 'academicInfoForm') {
      this.loadAccademic(false);
    }
  
    this.expansionStatus[section] = false;
    this.editMode[section] = false;
    this[section].markAsPristine();
    this[section].markAsUntouched();
  }
  
  // New method to reset a form to its original values
  resetForm(section: string) {
    switch (section) {
      case 'personalInfoForm':
        this.personalInfoForm.patchValue({
          name: this.currentLead?.name || '',
          lastName: this.currentLead?.lastName || '',
          birth_date: this.currentLead.birth_date || null,
          gender: this.currentLead?.gender || '',
          marital_status: this.currentLead?.marital_status || '',
          race_ethnicity: this.currentLead?.race_ethnicity || '',
          highestDegreeEarned: this.currentLead?.highestDegreeEarned || '',
          highSchoolYearGraduation: this.currentLead?.highSchoolYearGraduation || '',
          studentUserId: this.currentLead.studentUser?.id || null,
        });
        break;
      case 'contactInfoForm':
        this.contactInfoForm.patchValue({
          email: this.currentLead?.email || '',
          prefix: this.currentLead?.prefix || '',
          phoneNumber: this.currentLead?.phoneNumber || '',
          mobilePhone: this.currentLead?.mobilePhone || '',
          homePhone: this.currentLead?.homePhone || '',
          address: this.currentLead?.address || '',
          city: this.currentLead?.city || '',
          state: this.currentLead?.state || '',
          zip_code: this.currentLead?.zip_code || '',
          preferred_contact_method:
            this.currentLead?.preferred_contact_method || '',
          best_time_to_call: this.currentLead?.best_time_to_call || '',
          studentUserId: this.currentLead.studentUser?.id || null,
        });
        break;
      case 'academicInfoForm':
        this.loadAccademic(false);
        break;
        case 'financialAidForm':
          this.loadFinancialAidData();
          this.fafsaPendingFile = null; // ADD THIS
          break;
      case 'citizenshipInfoForm':
        this.citizenshipInfoForm.patchValue({
          usCitizen: this.currentLead?.usCitizen,
          vaMilitary: this.currentLead?.vaMilitary,
        });
        break;
      case 'referralInfoForm':
        this.loadReferralData();
        break;
    }
  }

  loadAccademic(edited: boolean) {
    if (edited) {
      // When in edit mode, ensure programs and cohorts are loaded
      if (this.academicDataLoaded) {
        // Ensure the current program is in the programs list
        if (this.currentLead?.program?.id && this.programs) {
          const programExists = this.programs.find(p => p.id === this.currentLead.program.id);
          if (!programExists) {
            // Add the current program to the list if it's not there
            const unavailableProgram = {
              ...this.currentLead.program,
              name: `${this.currentLead.program.name} (No longer available)`,
              isUnavailable: true
            };
            this.programs = [...this.programs, unavailableProgram];
          }
        }
        
        // Ensure the current cohort is in the cohorts list
        if (this.currentLead?.cohort?.id && this.cohorts) {
          const cohortExists = this.cohorts.find(c => c.id === this.currentLead.cohort.id);
          if (!cohortExists) {
            // Add the current cohort to the list if it's not there
            const unavailableCohort = {
              ...this.currentLead.cohort,
              title: `${this.currentLead.cohort.title} (No longer available)`,
              isUnavailable: true
            };
            this.cohorts = [...this.cohorts, unavailableCohort];
          }
        }
      }
      
      this.academicInfoForm.patchValue({
        program: this.currentLead?.program?.id?.toString() || '',
        cohort_start: this.currentLead?.cohort?.id?.toString() || '',
        campus: this.currentLead?.campus?.id?.toString() || '',
      });
    } else {
      // Display mode - just use the lead's existing data
      this.academicInfoForm.patchValue({
        program: this.currentLead?.program?.name?.toString() || '',
        cohort_start: this.currentLead?.cohort?.title?.toString() || '',
        campus: this.currentLead?.campus?.name?.toString() || '',
      });
    }
  }

  loadInfo(edited: boolean) {
    this.leadInfoForm.patchValue({
      user: this.currentLead?.user?.id ? `${this.currentLead?.user?.name?.toString()} ${this.currentLead?.user?.lastName?.toString()}` : 'No owner',
      secondaryUser: this.currentLead?.secondaryUser?.id ? `${this.currentLead?.secondaryUser?.name?.toString()} ${this.currentLead?.secondaryUser?.lastName?.toString()}` : 'No secondary owner',
    });
  }

  async togglePin(event: any) {
    this.currentLead.note = this.currentLead.note.filter(
      (x) => x.id !== event.id,
    );

    const response = await firstValueFrom(
      this.noteService.patch({ pined: !event.pined }, event.id),
    );

    if (response) {
      const obj = { data: response, location: 'note' };
      this.CommunicationService.updateData({
        type: 'focusNoteComponent',
        obj,
      });
    }
  }

  async markCompleted(event: any) {
    if (this.currentLead) {
      event.lead = {
        ...(event.lead || {}),
        id: this.currentLead.id,
        status: this.currentLead.status,
        enrolled_at: this.currentLead.enrolled_at,
        isDuplicated: this.currentLead.isDuplicated,
        fa_advisor_id: this.currentLead.fa_advisor_id ?? null,
      };
    }
    const existingTask = this.currentLead.tasks.find((x) => x.id === event.id);
    const data = await this.activityCompletionService.markActivityAsDone(event);
    if (!data) {
      return;
    }

    // Handle reschedule case using newTask and oldTask (same as list-view)
    if (data.newAppointment?.newTask || data.newAppointment?.oldTask) {
      // Remove old task from focus list
      this.currentLead.tasks = this.currentLead.tasks.filter(
        (x) => x.id !== event.id,
      );
      return;
    }

    const response = data.data;
    const patched = { ...existingTask, ...(response || {}) };
    const isNowCompleted = !!patched.completed;

    if (isNowCompleted) {
      this.currentLead.tasks = this.currentLead.tasks.filter(
        (x) => x.id !== event.id,
      );
    } else {
      this.currentLead.tasks = this.currentLead.tasks.map((x) =>
        x.id === event.id ? patched : x,
      );
    }

    if (response) {
      const obj = { data: patched, location: 'activity', update: !isNowCompleted, updateActivityTime: isNowCompleted };
      this.CommunicationService.updateData({
        type: 'focusActivityComponent',
        obj,
      });
    }
  }

  async onEmailBlur() {
    const email = this.contactInfoForm.get('email');
    try {
      const response = await firstValueFrom(
        this.userService.checkEmailExists(email.value, this.currentLead?.studentUser?.id),
      );
      if (response) {
        email.setErrors({ emailExists: response });
      }
    } catch (err) {
    }
  }

  async openActivityModal(task: any) {
    const user = await this.userDataService.getUserData();
    const hourSegments = user?.Company?.activity_activity_duration || 30;
  
    await this.activityLeadService.openActivityOnlyModal({
      ...task,
      lead: {
        id: this.currentLead.id,
        fullName: this.currentLead.fullName,
        email: this.currentLead.email,
        prefix: this.currentLead.prefix,
        phoneNumber: this.currentLead.phoneNumber,
        campus: this.currentLead.campus,
        status: this.currentLead.status,
        enrolled_at: this.currentLead.enrolled_at,
        isDuplicated: this.currentLead.isDuplicated,
      },
      start: new Date(task.startDate),
      end: new Date(task.endDate),
      id: task.id,
      hourSegments: hourSegments,
      detailed: true,
      hideCalendarProps: true,
      isExternal: true,
      listView: true,
      defaultLead: this.currentLead.id,
      isModal: true,
      editMode: true
    });
  }

  callDialog(header: string, content: string, type = 'info', isInfo = false) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header,
        content,
        type,
        isInfo
      },
      width: '500px',
    });

    return dialogRef.afterClosed().toPromise();
  }

  async sendCredentials() {
    if (!this.currentLead?.studentUser) {
      this.notificationService.showNonErrorSnackBar('This lead does not have a student account', 2000);
      return;
    }
  
    const confirmed = await this.callDialog(
      'Send Credentials',
      `Are you sure you want to send login credentials to ${this.currentLead.email}? This will generate a new password.`,
      'info',
      false
    );
  
    if (confirmed) {
      try {
        const response = await firstValueFrom(
          this.leadService.sendCredentials(this.currentLead.id)
        );
        
        if (response.success) {
          this.notificationService.showNonErrorSnackBar(response.message, 3000);
        }
      } catch (error) {
        this.notificationService.showNonErrorSnackBar('Failed to send credentials', 2000);
      }
    }
  }

  private setupFocusSocketListener(): void {
    this.socketService.getLeadUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((update) => {
        // Only handle updates for current lead
        if (!this.currentLead || update.leadId !== this.currentLead.id) {
          return;
        }
  
        switch (update.type) {
          case 'note_added':
            this.handleFocusNoteAdded(update.data, update.userId);
            break;
          case 'note_updated':
            this.handleFocusNoteUpdated(update.data, update.userId);
            break;
          case 'note_deleted':
            this.handleFocusNoteDeleted(update.data.id, update.userId);
            break;
        }
      });
  
    // Listen for inbox messages (incoming messages from leads)
    this.socketService.getInboxMessages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.handleFocusInboxMessage(data);
      });
  }

  /**
   * Handle note added - add to focus if pinned
   * Skip if this is our own event (already handled locally)
   */
  private handleFocusNoteAdded(note: any, eventUserId?: number): void {
    // Skip if this is our own event (already handled locally via CommunicationService)
    if (eventUserId && eventUserId === this.currentUserId) {
      return;
    }

    if (note.pined) {
      // Initialize note array if needed
      if (!this.currentLead.note) {
        this.currentLead.note = [];
      }
      
      // Check if already exists
      if (!this.currentLead.note.some(n => n.id === note.id)) {
        this.currentLead.note = [...this.currentLead.note, note];
      }
    }
  }

  /**
   * Handle note updated - add/remove from focus based on pin status
   * Skip if this is our own event (already handled locally)
   */
  private handleFocusNoteUpdated(note: any, eventUserId?: number): void {
    // Skip if this is our own event (already handled locally via CommunicationService)
    if (eventUserId && eventUserId === this.currentUserId) {
      return;
    }

    // Initialize note array if needed
    if (!this.currentLead.note) {
      this.currentLead.note = [];
    }

    const existingIndex = this.currentLead.note.findIndex(n => n.id === note.id);
    
    if (note.pined) {
      // Note is pinned - should be in focus
      if (existingIndex === -1) {
        // Add to focus
        this.currentLead.note = [...this.currentLead.note, note];
      } else {
        // Update existing
        this.currentLead.note[existingIndex] = note;
        this.currentLead.note = [...this.currentLead.note];
      }
    } else {
      // Note is unpinned - remove from focus
      if (existingIndex !== -1) {
        this.currentLead.note.splice(existingIndex, 1);
        this.currentLead.note = [...this.currentLead.note];
      }
    }
  }

  /**
   * Handle incoming message from lead - update Focus chat section
   */
  private handleFocusInboxMessage(data: any): void {
    const leadId = data.notification?.record_id;
    const message = data.message;

    // Only process if it's for the current lead
    if (!leadId || leadId !== this.currentLead?.id) {
      return;
    }

    if (message) {
      // Update chat with the new message (replace existing)
      this.chat = {
        id: message.id,
        content: message.content,
        subject: message.subject || null,
        from: message.from || null,
        to: message.to || null,
        direction: message.direction || 'received',
        isSms: message.isSms,
        isError: false,
        error_message: null,
        created_at: message.created_at || new Date().toISOString(),
        createdBy: message.createdBy || null,
        attachments: message.attachments || [],
        typeEmail: message.typeEmail || null,
        seen: false,
        delivered: true,
        sent: true,
        temporary_failure: false,
        status: 'delivered'
      };

      // Show the chat section since lead has sent a message
      this.showChat = true;

      // Update currentLead's is_last_message_from_lead flag
      if (this.currentLead) {
        this.currentLead.is_last_message_from_lead = true;
      }
    }
  }

  /**
   * Handle note deleted - remove from focus
   * Skip if this is our own event (already handled locally)
   */
  private handleFocusNoteDeleted(noteId: number, eventUserId?: number): void {
    // Skip if this is our own event (already handled locally)
    if (eventUserId && eventUserId === this.currentUserId) {
      return;
    }

    if (!this.currentLead.note) return;
    
    const index = this.currentLead.note.findIndex(n => n.id === noteId);
    if (index !== -1) {
      this.currentLead.note.splice(index, 1);
      this.currentLead.note = [...this.currentLead.note];
    }
  }

  loadFinancialAidData() {
    if (!this.currentLead) return;

    this.financialAidForm.patchValue({
      fa_status_id: this.currentLead.fa_status_id,
      fa_overall_status_id: this.currentLead.fa_overall_status_id,
      fa_dependency_type_id: this.currentLead.fa_dependency_type_id,
      fa_verification_status_id: this.currentLead.fa_verification_status_id,
      fafsa_filed: this.currentLead.fafsa_filed || false,
      fafsa_submitted_at: this.currentLead.fafsa_submitted_at || null,
      fa_appointment_at: this.currentLead.fa_appointment_at || null,
      fa_completed_at: this.currentLead.fa_completed_at || null,
      sar_received: this.currentLead.sar_received || false,
      sai_amount: this.currentLead.sai_amount || null,
      award_letter_sent: this.currentLead.award_letter_sent || false,
      award_letter_sent_at: this.currentLead.award_letter_sent_at || null,
      aid_accepted: this.currentLead.aid_accepted === true ? true : this.currentLead.aid_accepted === false ? false : 'pending',
      aid_amount: this.currentLead.aid_amount || null,
      fa_advisor_id: this.currentLead.fa_advisor_id,
      expected_start_date: this.currentLead.expected_start_date || null,
      fa_notes: this.currentLead.fa_notes || '',
    });
  }


  async saveFinancialAid() {
    const formValue = this.financialAidForm.value;
    const payload: any = {};
    const fields = Object.keys(formValue);
  
    for (const field of fields) {
      const formVal = formValue[field];
      const originalVal = this.currentLead?.[field];
      const normalized = (v: any) => (v === '' || v === undefined || v === 'pending' ? null : v);
      if (normalized(formVal) !== normalized(originalVal)) {
        payload[field] = normalized(formVal);
      }
    }
  
    // Exit only if nothing changed at all
    if (Object.keys(payload).length === 0 && !this.fafsaPendingFile) return;
  
    try {
      if (Object.keys(payload).length > 0) {
        const response = await firstValueFrom(
          this.leadService.updateFinancialAid(this.currentLead.id, payload),
        );
        if (response) {
          Object.assign(this.currentLead, response);
          this.loadFinancialAidData();
        }
      }
  
      if (this.fafsaPendingFile) {
        const uploadResult = await firstValueFrom(
          this.leadService.uploadFafsaDocument(this.currentLead.id, this.fafsaPendingFile)
        );
        Object.assign(this.currentLead, uploadResult);
        this.fafsaPendingFile = null;
      }
  
      this.notificationService.showNonErrorSnackBar('Financial aid saved.', 2000); // ← single toast
    } catch (error) {
      this.notificationService.showNonErrorSnackBar('Failed to save financial aid', 2000);
    }
  }


    faDateValidator(group: FormGroup): ValidationErrors | null {
      const appointment = group.get('fa_appointment_at')?.value;
      const completed = group.get('fa_completed_at')?.value;
    
      if (appointment && completed && new Date(appointment) > new Date(completed)) {
        return { appointmentAfterCompleted: true };
      }
      return null;
    }

    onFafsaFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
      if (!input.files?.length) return;
      this.fafsaPendingFile = input.files[0];
      input.value = '';
    }
    
    async openFafsaDocument(): Promise<void> {
      try {
        const result = await firstValueFrom(
          this.leadService.getFafsaDocumentUrl(this.currentLead.id)
        );
        window.open(result.url, '_blank');
      } catch {
        this.notificationService.showNonErrorSnackBar('Failed to open document', 2000);
      }
    }
    
    async deleteFafsaDocument(): Promise<void> {
      const confirmed = await this.callDialog('Delete Document', 'Are you sure you want to delete this FAFSA document?');
      if (!confirmed) return;
    
      try {
        await firstValueFrom(this.leadService.deleteFafsaDocument(this.currentLead.id));
        this.currentLead.fafsa_document_key = null;
        this.currentLead.fafsa_document_name = null;
        this.notificationService.showNonErrorSnackBar('Document deleted', 2000);
      } catch {
        this.notificationService.showNonErrorSnackBar('Failed to delete document', 2000);
      }
    }
    
    /**
 * Reset all edit modes, close expansion panels, and clear cached data
 * when navigating between leads.
 */
private resetComponentState(): void {
  // Close all edit modes
  Object.keys(this.editMode).forEach(key => {
    this.editMode[key] = false;
  });

  // Reset all expansion panel tracking
  Object.keys(this.expansionStatus).forEach(key => {
    this.expansionStatus[key] = false;
  });

  // Physically close all open expansion panels
  if (this.accordion) {
    this.accordion.closeAll();
  }

  // Reset academic data so it reloads for the new lead
  this.academicDataLoaded = false;


  // Mark all forms as pristine/untouched to clear dirty state
  const formNames = [
    'personalInfoForm', 'contactInfoForm', 'academicInfoForm',
    'leadInfoForm', 'citizenshipInfoForm', 'referralInfoForm',
    'paymentPlanForm', 'financialAidForm'
  ];
  formNames.forEach(name => {
    if (this[name]) {
      this[name].markAsPristine();
      this[name].markAsUntouched();
    }
  });
}

paymentPlanDateValidator(group: FormGroup): ValidationErrors | null {
  const start = group.get('payment_plan_start_date')?.value;
  const end = group.get('payment_plan_end_date')?.value;
  if (start && end && new Date(start) > new Date(end)) {
    return { startAfterEnd: true };
  }
  return null;
}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}